import { getProductThemeFromType } from "@components/common/Header/utils";
import { IconState } from "@components/molecules/IconUtils";
import { ProductCategory } from "@utils/constants";
import { useRef, useState } from "react";
import { Dimensions, Platform } from "react-native";

const useThreeDotMenuState = (initialSelectedState = false) => {
  const [placement, setPlacement] = useState("top");
  const screenHeight = Dimensions.get("window").height;

  const [threeDotIconState, setThreeDotIconState] = useState(
    initialSelectedState ? IconState.Selected : IconState.Unselected
  );
  const [threeDotMenuOpen, setThreeDotMenuOpen] = useState(false);

  const threeDotMenuOpenRef = useRef(false);

  const handlePressIn = (event: any) => {
    setThreeDotIconState(IconState.Pressed);

    if (Platform.OS === "android") {
      const touchY = event.nativeEvent.pageY;
      if (touchY > screenHeight - 300) {
        setPlacement("top");
      } else {
        setPlacement("bottom");
      }
    }
  };

  const handlePressOut = () => {
    if (!threeDotMenuOpenRef.current) {
      setThreeDotIconState(IconState.Unselected);
    } else {
      setThreeDotIconState((prevState) =>
        prevState === IconState.Pressed ? IconState.Selected : prevState
      );
    }
  };

  const handlePress = () => {
    const nextOpen = !threeDotMenuOpenRef.current;
    setThreeDotMenuOpenTracked(nextOpen);
    setThreeDotIconState(nextOpen ? IconState.Selected : IconState.Unselected);
  };

  const setThreeDotMenuOpenTracked = (value: boolean) => {
    threeDotMenuOpenRef.current = value;
    setThreeDotMenuOpen(value);
  };

  const handleClose = () => {
    setThreeDotMenuOpenTracked(false);
    setThreeDotIconState(IconState.Unselected);
  };

  const getThreeDotIconBackgroundColor = (
    theme: any,
    productType: ProductCategory = ProductCategory.DEFAULT,
    isFavoritesIcon?: boolean,
    isDisabled?: boolean
  ) => {
    if (isDisabled) {
      return theme["core-02"];
    }
    if (threeDotMenuOpen) {
      return theme["core-05"];
    }
    const productTheme = getProductThemeFromType(productType);
    switch (threeDotIconState) {
      case IconState.Selected:
        return theme["core-05"];
      case IconState.Pressed:
        return theme["core-05"];
      default:
        return (theme.isLargeScreen && isFavoritesIcon) ||
          productType === ProductCategory.DEFAULT
          ? theme["core-06"]
          : theme[`${productTheme}-03`];
    }
  };

  const getThreeDotIconColor = (theme: any, productType: ProductCategory) => {
    if (threeDotMenuOpen) {
      return theme["core-01"];
    }
    const productTheme = getProductThemeFromType(productType);
    switch (threeDotIconState) {
      case IconState.Selected:
      case IconState.Pressed:
        return theme["core-01"];
      default:
        return theme[`${productTheme}-06`];
    }
  };

  return {
    threeDotIconState,
    setThreeDotIconState,
    threeDotMenuOpen,
    setThreeDotMenuOpen: setThreeDotMenuOpenTracked,
    handlePressIn,
    handlePressOut,
    handlePress,
    handleClose,
    getThreeDotIconBackgroundColor,
    getThreeDotIconColor,
    placement,
  };
};

export default useThreeDotMenuState;
